import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const ACTIVITYMOMENT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ActivityMoment.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const ACTIVITYMOMENT_CONFIG = {
  entityName: 'ActivityMoment',
  localizationKey: 'Controlling::Entity.ActivityMoment',
  fields: ACTIVITYMOMENT_FIELDS,
  permission: 'ControllingActivities.ActivityMoments',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
